import { css } from 'design'
import React from 'react'

import { WidgetHeaderBar } from '../../components/live_chat_widget/widget_header_bar'
import { NameAndEmailForm } from '../../components/timelines/widget/name_and_email_form'
import { Composer } from '../../components/topics/composer/composer'
import { WidgetPageContainer } from './widget_page_container'

export const LandingMessengerPage = () => {
  return (
    <WidgetPageContainer videoVariant={false}>
      <WidgetHeaderBar bgVariant />
      <div className={spacerStyles()} />
      <NameAndEmailForm
        data-timeline-id={'widget-name-and-email-form'}
        className={nameAndEmailFormStyles()}
      />
      <Composer />
      <div id="dropzone" className="dropzone" />
    </WidgetPageContainer>
  )
}

const spacerStyles = css({
  flexGrow: 1,
})

const nameAndEmailFormStyles = css({
  marginBottom: 24,
})
